/* hg-reviews.js — aligne le bloc avis des fiches produit sur la réalité.
   Le gabarit sections/hg-product.liquid contient trois éléments trompeurs :
   un badge « ✔ Vérifié » sur chaque carte, un titre « Avis clients vérifiés »,
   et une note « 4.8 — 1 247 avis » écrite en dur, identique sur tous les
   produits. Les avis affichés proviennent de la fiche Google Hocman Garden :
   ils concernent l'entreprise, pas un produit en particulier.
   La note et le nombre sont relus depuis l'en-tête, qui lui est alimenté par
   les réglages de section (review_rating / review_count) — un seul endroit
   à modifier. S'exécute sur toutes les fiches produit. */
(function () {
  'use strict';

  var GOOGLE_URL = 'https://www.google.com/maps?cid=16719574525584523013';

  function headerRating() {
    var el = document.querySelector('.hg-prod-header__stars');
    if (!el) return null;
    var spans = el.querySelectorAll('span');
    if (spans.length < 2) return null;
    var txt = spans[spans.length - 1].textContent.trim();
    var parts = txt.split('—');
    if (parts.length < 2) return null;
    return { note: parts[0].trim(), count: parts.slice(1).join('—').trim() };
  }

  function clean() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.hg-review-card__badge'),
      function (b) { if (/v[ée]rifi/i.test(b.textContent)) b.remove(); }
    );

    var head = document.querySelector('.hg-prod-reviews__header');
    if (head) {
      var h2 = head.querySelector('h2');
      if (h2 && /avis clients v[ée]rifi/i.test(h2.textContent)) {
        h2.textContent = '⭐ Ce que nos clients nous disent';
      }
      var p = head.querySelector('p');
      if (p) {
        p.textContent = '';
        p.appendChild(document.createTextNode('Avis publiés sur notre fiche Google '));
        var a = document.createElement('a');
        a.href = GOOGLE_URL;
        a.target = '_blank';
        a.rel = 'noopener nofollow';
        a.textContent = 'Hocman Garden, Vias';
        a.style.color = '#2e7d00';
        a.style.fontWeight = '700';
        p.appendChild(a);
      }
    }

    var glob = document.querySelector('.hg-prod-reviews__global');
    var r = headerRating();
    if (glob && r) {
      glob.innerHTML = '';
      var stars = document.createElement('span');
      stars.style.cssText = 'color:#f5a623;font-size:20px';
      stars.textContent = '★★★★★';
      var note = document.createElement('span');
      note.style.cssText = 'font-size:22px;font-weight:900;color:var(--hg-navy)';
      note.textContent = r.note;
      var cnt = document.createElement('a');
      cnt.href = GOOGLE_URL;
      cnt.target = '_blank';
      cnt.rel = 'noopener nofollow';
      cnt.style.cssText = 'font-size:12px;color:#2e7d00;font-weight:700;text-decoration:underline';
      cnt.textContent = r.count;
      glob.appendChild(stars);
      glob.appendChild(note);
      glob.appendChild(cnt);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clean);
  } else {
    clean();
  }
})();
